<template class="template-communicate">
    <div class="communicate" style="position:relative">
        <div class="content-pc" style="border-radius:4px;overflow:hidden">
            <div class="user-content" v-if="currentSelect=='user'">
                <!-- <div class="condition" v-if="ifLogin">
                    <div style="height:48px;line-height:48px;padding:0 24px;background:rgba(34, 215, 187, 1);color:#fff;font-size:14px;">项目选择</div>
                    <div class="condition-content condition-content-private">
                        <ul>
                            <li :class="{checked:index==privateItem || item.id == defaultPrivateProId}" v-for="(item, index) in privateProList" :key="index" @click="selectPrivateSence(item,index)">
                                <img src="../../assets/img/user-1.png" alt="">
                                <span :title="item.name">{{item.name.length>8?(item.name).substring(0,8)+'...':item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div> -->
                <div class="info">
                    <div class="info-top">
                        <span style="margin-right:12px">{{projectName2.length>12?(projectName2).substring(0,12)+'...':projectName2}}</span>
                    </div>
                    <div class="info-content" id="chatDiv">
                        <div v-for="(item, index) in privateChatContent" :key="index" class="dialog-list">
                            <div v-if="item.role=='robot'" class="left" style="max-width:60%">
                                <div :class="{'bgleft':item.role=='robot'}">
                                    <!-- <img src="../../assets/img/chart.png" class="left" alt=""> -->
                                    <div class="content-info left">
                                        <div style="font-size:14px">{{item.content}}</div>
                                        <div style="font-size:12px;text-align:left">{{item.time}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.role=='user'" class="right" style="max-width:60%;cursor:pointer" @click="queryUserIntentionData(index,item.content)">
                                <div :class="{'bgright':item.role=='user'}">
                                    <!-- <img :src="userAvatar" class="right" alt=""> -->
                                    <div class="content-info right">
                                        <div style="font-size:14px">{{item.content}}</div>
                                        <div style="font-size:12px;text-align:right">{{item.time}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-foot" style="position:relative">
                        <div v-if="isFinish" style="position:absolute;top:-30px;left:43%;font-size:16px;color:#000">通话已结束</div>
                        <div>
                            <div class="info-input">
                                <a-input type="textarea" :disabled="isFinish" @keyup.13="sendPrivate" v-model="privateContent" autoSize  placeholder="请输入对话内容"/>
                            </div>
                            <div class="info-btn">
                                <div class="btn-group">
                                    <span @click="resetPrivate" style="margin-right:24px;">
                                        <a-icon type="sync" />
                                        重置
                                    </span>
                                    <span style="margin-right:24px;" @click="sendPrivate">发送</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a-icon @click="openDetail(false)" v-if="ifOpenDetail&&ifLogin" type="right-circle"  style="position:absolute;right:-10px;top:45%;color:rgba(204, 204, 204, 1);font-size:24px"/>
                    <a-icon type="left-circle" @click="openDetail(true)" v-if="!ifOpenDetail&&ifLogin" style="position:absolute;right:-10px;top:45%;color:rgba(204, 204, 204, 1);font-size:24px"/>
                </div>
                <div class="detail-content" v-if="ifOpenDetail&&ifLogin">
                    <!-- <div style="height:48px;background:rgba(236, 238, 239, 0.7)"></div> -->
                    <div style="height:80px;padding:16px 16px 0 16px;">
                        <div>
                            <span style="color:rgba(51, 51, 51, 1);font-size:14px;font-weight:bold">纠错学习</span>
                        </div>
                        <div style="margin-top:13px;">
                            <span style="color:rgba(204, 204, 204, 1);font-size:14px;">已训练：</span>
                            <span style="color:rgba(34, 215, 187, 1);font-size:14px;">{{trainedCount}}</span>
                            <span style="color:rgba(204, 204, 204, 1);font-size:14px;margin-left:24px">待训练：</span>
                            <span style="color:rgba(34, 215, 187, 1);font-size:14px;">{{unTrainedCount}}</span>
                        </div>
                        <a-divider style="margin-top:16px;" />
                    </div>
                    <div style="clear:both"></div>
                    <ul style="flex:1;overflow-y:auto;padding:6px 10px 16px 24px">
                        <li v-for="(item, index) in intentionList" :key="index" style="position:relative;padding-left:0px;display:flex;border-bottom:1px solid rgba(238, 238, 238, 1);font-size:12px;padding:16px 0">
                            <div style="flex:1">
                                <div style="text-align:left;color:rgba(204, 204, 204, 1);font-size:12px;">意图</div>
                                <div style="color:rgba(80, 80, 80, 1)">{{item.name}}</div>
                            </div>
                            <div style="display:inline-block;width:50px;text-align:center">
                                <div style="color:rgba(204, 204, 204, 1);font-size:12px;">数量</div>
                                <div style="color:rgba(80, 80, 80, 1)">{{item.sampleCount}}</div>
                            </div>
                            <div style="display:inline-block;width:50px;text-align:center">
                                <div style="color:rgba(204, 204, 204, 1);font-size:12px;">分值</div>
                                <div style="color:rgba(80, 80, 80, 1)">{{(item.score).toFixed(2)}}</div>
                            </div>
                            <span @click="addToIntention(item.name)" style="margin-top:16px;display:inline-block;width:32px;height:32px;color:rgba(34, 215, 187, 1);border:1px solid rgba(34, 215, 187, 1);border-radius:4px;line-height:32px;text-align:center;cursor:pointer">训练</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="voiceId"></div>
        </div>
        <div class="content-phone">
            <div style="display:flex;flex-direction:column;height:100%">
                <div style="flex:1;padding:16px;overflow-y:auto;">
                    <div class="chat-content">
                        <div v-for="(item, index) in privateChatContent" :key="index" class="dialog-list">
                            <div v-if="item.role=='robot'" class="left" style="max-width:60%">
                                <div :class="{'bgleft':item.role=='robot'}">
                                    <img src="../../assets/img/chart.png" class="left" alt="">
                                    <div style="flex:1;background:#fff;padding:4px 8px;border-radius:4px" class="content-info left">
                                        <div style="font-size:14px">{{item.content}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.role=='user'" class="right" style="max-width:60%;cursor:pointer">
                                <div :class="{'bgright':item.role=='user'}">
                                    <div style="flex:1;background:rgba(34, 215, 187, 1);padding:4px 8px;border-radius:4px" class="content-info right">
                                        <div style="font-size:14px">{{item.content}}</div>
                                    </div>
                                    <img src="../../assets/img/avator/admin-15.jpg" class="right" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display:flex;width:100%;height:40px;padding:0 16px;margin-bottom:10px;position:relative">
                    <div v-if="isFinish" style="position:absolute;top:-30px;left:50%;font-size:16px;color:#000;margin-left:-40px">通话已结束</div>
                    <a-input  :disabled="isFinish" v-model="publicContent" style="flex:1;height:40px"/>
                    <a-button type="primary" style="width:66px;height:40px;margin-left:8px" @click="sendPublic">
                        发送
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Communication',
    props: {
        msg: String
    },
    data() {
        return {
            currentSelect: 'user',
            ifLogin:false,
            privateProList: [],
            privateItem: null,
            privateRoomId: '',
            privateProjectId: '',
            privateContent: '',
            defaultPrivateProId: '',
            privateChatContent: [],
            roomId: '',
            projectName2: '项目名称',
            intentionList: [],
            projectId3: '',
            useravatar: '',
            loading: true,
            trainedCount: 0,
            unTrainedCount: 0,
            privateChatObj: {},
            ifOpenDetail: true,
            countDown: 120,
            countTimeTool: '',
            recordList: [],
            publicContent: '',
            isFinish: false,
        };
    },
    methods: {
        queryPrivateProData() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/dropdown/project', 
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    if(response.data.data.length > 0){
                        this.privateProList = response.data.data
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        selectPrivateSence(item,index) {
            if(item.id != this.privateProjectId){
                this.isFinish = false
                this.privateItem = index
                this.privateProjectId = item.id
                this.defaultPrivateProId = ''
                this.privateChatContent = []
                this.projectName2 = item.name
                this.intentionList = []
                this.privateChatObj = {}
                this.queryPrivateRoomId(item.id)
                this.queryTrainSample(item.id)
                clearInterval(this.countTimeTool)
                this.countDown = 120
            }
        },
        queryPrivateRoomId(id) {
            this.axios.post('/api/project/chat', {
                projectId: id,
                roomId: '',
                content: ''
            })
            .then(response=> {
                if(response.data.code == 0){
                    clearInterval(this.countTimeTool)
                    this.countDown = 120
                    this.privateRoomId = response.data.data.roomId
                    let obj = {}
                    obj.role = 'robot'
                    obj.content = response.data.data.responseContent
                    obj.logTime = response.data.data.logTime
                    this.privateChatContent.push(obj)
                    this.readVoice(response.data.data.voiceUrl)
                    if(response.data.data.isFinish){
                        this.isFinish = true
                    }else{
                        this.carryTimeOut()
                    }
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        resetPrivate() {
            this.isFinish = false
            this.privateContent = ''
            this.privateChatContent = []
            this.privateChatObj = {}
            clearInterval(this.countTimeTool)
            this.countDown = 120
            this.queryPrivateRoomId(this.privateProjectId)
        },
        trim(s){
            return s.replace(/(^\s*)|(\s*$)/g, "");
        },
        writeCurrentDate() {
            let now = new Date();
            let year = now.getFullYear(); //得到年份
            let month = now.getMonth();//得到月份
            let date = now.getDate();//得到日期
            let hour = now.getHours();//得到小时
            let minu = now.getMinutes();//得到分钟
            let sec = now.getSeconds();//得到秒
            let MS = now.getMilliseconds();//获取毫秒
            month = month + 1;
            if (month < 10) month = "0" + month;
            if (date < 10) date = "0" + date;
            if (hour < 10) hour = "0" + hour;
            if (minu < 10) minu = "0" + minu;
            if (sec < 10) sec = "0" + sec;
            if (MS < 10) MS = "0" + MS;
            let time = "";
            time = year + "/" + month + "/" + date  + " " + hour + ":" + minu + ":" + sec + " " ;
            return time
        },
        randomTime() {
            let max = 3000;
            let min = 1000;
            return Math.round(Math.random()*(max-min)+min)
        },
        scrollTopCon() {
            this.$nextTick(function() {
                let div = document.getElementById('chatDiv');
                div.scrollTop = div.scrollHeight;
            })
        },
        readVoice(url) {
            let audio = "<audio autoplay=\"autoplay\">" + "<source src=\""+url+"" + "\" type=\"audio/mpeg\">" + "<embed height=\"0\" width=\"0\" src=\""+url+"" + "\">" + "</audio>";
            let oBox=document.getElementById("voiceId");
            oBox.innerHTML = audio
        },
        sendNullContent() {
            let currentLength = this.privateChatContent.length
            this.axios.post('/api/project/chat', {
                projectId: this.privateProjectId,
                roomId: this.privateRoomId,
                content: ""
            })
            .then(response=> {
                if(response.data.code == 0){
                    clearInterval(this.countTimeTool)
                    this.countDown = 120
                    let newObj = {}
                    newObj.role = 'robot'
                    newObj.logTime = response.data.data.logTime
                    newObj.content = response.data.data.responseContent
                    this.privateChatContent.push(newObj)
                    this.readVoice(response.data.data.voiceUrl)
                    this.scrollTopCon()
                    this.privateChatObj[currentLength] = response.data.data.log.intentionList
                    if(response.data.data.isFinish){
                        this.isFinish = true
                    }else{
                        this.carryTimeOut()
                    }
        
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        sendPrivate() {
            this.privateContent = (this.privateContent).replace(/\s/g,"");
            if(this.privateProjectId == ''){
                this.$message.error('请先选择项目');
            }else if(this.privateContent.length == 0){
                this.$message.error('请输入对话内容');
                this.privateContent = ''
            }else{
                let obj = {}
                obj.role = 'user'
                obj.content = this.privateContent
                obj.logTime = this.writeCurrentDate()
                let currentLength = this.privateChatContent.length
                this.privateChatContent.push(obj)
                this.scrollTopCon()
                this.axios.post('/api/project/chat', {
                    projectId: this.privateProjectId,
                    roomId: this.privateRoomId,
                    content: this.privateContent
                })
                .then(response=> {
                    if(response.data.code == 0){
                        clearInterval(this.countTimeTool)
                        this.countDown = 120
                      
                        let newObj = {}
                        newObj.role = 'robot'
                        newObj.logTime = response.data.data.logTime
                        newObj.content = response.data.data.responseContent
                        let randomTime = this.randomTime()
                        setTimeout(()=>{
                            this.privateChatContent.push(newObj)
                            this.readVoice(response.data.data.voiceUrl)
                            this.scrollTopCon()
                            this.privateChatObj[currentLength] = response.data.data.log.intentionList
                           if(response.data.data.isFinish){
                                this.isFinish = true
                            }else{
                                this.carryTimeOut()
                            }
                        },randomTime)
                        
         
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
                this.privateContent = ''
            }
        },
        addToIntention(name) {
            this.axios.post('/api/callRecord/intention', {
                projectId: this.privateProjectId,
                userWords: this.msgCurrentWord,
                intention: name
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('操作成功');
                }else{
                    this.$message.error('操作失败');
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryUserIntentionData(index,content) {
            if(this.ifLogin){
                this.intentionList = this.privateChatObj[index]
                this.msgCurrentWord = content
            }
        },
        queryTrainSample(id) {
            this.axios({
                method:'get',
                url:'/api/intention/statistic', 
                params: {
                    projectId: id
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.trainedCount = response.data.data.trainedCount
                    this.unTrainedCount = response.data.data.unTrainedCount
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        openDetail(bool) {
            this.ifOpenDetail = bool
        },
        carryTimeOut() {
            this.countTimeTool = setInterval(this.myInterval,1000)
        },
        myInterval(){
            this.countDown -- 
            if(this.countDown == 0){
                clearInterval(this.countTimeTool)
                this.sendNullContent()
            }
        },
        sendPublic() {
            this.publicContent = (this.publicContent).replace(/\s/g,"");
            if(this.publicContent.length == 0){
                this.$message.error('请输入对话内容');
                this.publicContent = ''
            }else{
                let obj = {}
                obj.role = 'user'
                obj.content = this.publicContent
                let currentLength = this.privateChatContent.length
                this.privateChatContent.push(obj)
                this.scrollTopCon()
                this.axios.post('/api/project/chat', {
                    projectId: this.privateProjectId,
                    roomId: this.privateRoomId,
                    content: this.publicContent
                })
                .then(response=> {
                    if(response.data.code == 0){
                        clearInterval(this.countTimeTool)
                        this.countDown = 120
                        let newObj = {}
                        newObj.role = 'robot'
                        newObj.content = response.data.data.responseContent
                        let randomTime = this.randomTime()
                        setTimeout(()=>{
                            this.privateChatContent.push(newObj)
                            this.readVoice(response.data.data.voiceUrl)
                            this.scrollTopCon()
                            this.privateChatObj[currentLength] = response.data.data.log.intentionList
                            if(response.data.data.isFinish){
                                this.isFinish = true
                            }else{
                                this.carryTimeOut()
                            }
                        },randomTime)
         
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
                this.publicContent = ''
            }
        },
    },
    mounted: function() {
        this.userAvatar = this.sessionData('get','avatar')==undefined?'/img/user-1.png':this.sessionData('get','avatar')
        if(this.$route.query.projectId != undefined){
            this.privateProjectId = this.$route.query.projectId
            this.defaultPrivateProId = this.$route.query.projectId
            this.projectName2 = this.$route.query.projectName
            this.queryPrivateRoomId(this.privateProjectId)
        }
        if(this.$route.query.type == 'public'){
            this.ifLogin = false
        }else{
            this.ifLogin = true
            this.queryPrivateProData()
        }
    },
}
</script>

<style scoped  lang="less">
    .communicate{
        .left{
            float: left;
        }
        .right{
            float: right;
        }
        height: 100%;
        display: flex;//flex布局
        justify-content: center;//使子项目水平居中
        align-items: center;//使子项目垂直居中
        .content-phone{
            display: none;
        }
        .content-pc{
            background: rgba(240, 242, 243, 1);
            width: 100%;
            height: 100%;
            padding: 24px 24px;
            margin: 0 auto;
            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
            // border: 1px solid rgba(34, 215, 187, 1);
            .user-content{
                float: left;
                height: 100%;
                width: 100%;
                display: flex;
                background: rgba(236, 238, 239, 0.7);
                .detail-content{
                    width:320px;
                    height:100%;
                    background:#fff;
                    margin-left: 24px;
                    overflow: hidden;
                    display:flex;
                    flex-direction: column;
                    border-radius: 8px;
                    div{
                        color: rgba(80, 80, 80, 1);
                        font-size: 12px;
                    }
                    ul{
                        li{
                            padding: 0 0 0 10px;
                            line-height: 30px;
                        }
                    }
                }
            }
            .condition{
                width: 240px;
                height: 100%;
                float: left;
                background: #fff;
                display: flex;
                flex-direction: column;
                .condition-content{
                    background: rgba(236, 238, 239, 1);
                    flex: 1;
                    overflow-y: auto;
                    li{
                        line-height: 45px;
                        cursor: pointer;
                        padding-left: 24px;
                    }
                    li:hover{
                        background: #fff;
                        color: rgba(80, 80, 80, 1);
                    }
                    img{
                        width: 32px;
                        height: 32px;
                        border-radius: 16px;
                        margin-right: 5px;
                    }
                    li.checked{
                        background: rgba(34, 215, 187, 0.2);
                        color: rgba(80, 80, 80, 1);
                    }
                }
            }
            .info{
                position: relative;
                flex: 1;
                height: 100%;
                float: left;
                background: #f6f7f8;
                display: flex;
                flex-direction: column;
                border-radius: 8px;
                overflow: hidden;
                .info-top{
                    height: 48px;
                    line-height: 48px;
                    background: rgba(246, 247, 248, 1);
                    color: rgba(80, 80, 80, 1);;
                    font-size: 14px;
                    padding: 0 24px;
                    border-bottom: 1px solid rgba(240, 240, 240, 1);
                }
                .info-content{
                    padding: 24px;
                    flex: 1;
                    overflow-y: auto;
                    background:rgba(246, 247, 248, 1);
                    border-bottom: 1px solid rgba(240, 240, 240, 1);
                    .dialog-list{
                        width: 100%;
                        font-size: 12px;
                        float: left;
                        margin-bottom: 16px;
                        .bgleft{
                            background: #fff;
                            padding: 8px 10px;
                            border-radius: 8px;
                            height: 100%;
                            float: left;
                            width: 100%;
                        }
                        .bgright{
                            background: #22d7bb;
                            padding: 8px 10px;
                            border-radius: 8px;
                            color: #fff;
                            height: 100%;
                            float: right;
                        }
                        img{
                            width: 32px;
                            height: 32px;
                            border-radius: 16px;
                            margin-right: 10px;
                            margin-left: 10px;
                        }
                    }
                }
                .info-foot{
                    height: 118px;
                    padding-bottom: 6px;
                    width: 100%;
                    background: #fff;
                    .info-input{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        // height: 88px;
                        textarea{
                            height: 100%;
                            border: none;
                            resize: none;
                        }
                    }
                    .info-btn{
                        height: 24px;
                        line-height: 24px;
                        position: absolute;
                        bottom: 0px;
                        right: 0px;
                        .btn-group{
                            float: right;
                            span{
                                font-size: 14px;
                                text-align: center;
                                cursor: pointer;
                                color: #22d7bb;
                            }
                        }
                    }
                    .info-phone{
                        height: 142px;
                        input{
                            height: 94px;
                            border: none;
                        }
                        span{
                            display: inline-block;
                            width: 60px;
                            height: 24px;
                            line-height: 24px;
                            margin-right: 16px;
                            font-size: 12px;
                            border-radius: 4px;
                            text-align: center;
                            cursor: pointer;
                            color: #fff;
                            background: rgba(0, 186, 173, 1);
                            float: right;
                            margin-top: 10px;
                        }
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 770px) {
        .communicate{
            display: block;
            justify-content: initial;//使子项目水平居中
            align-items: initial;//使子项目垂直居中
            height: 100%;;
            .content-pc{
                display:none;
            }
            .content-phone{
                display: block;
                height: 100%;
                background: rgba(246, 247, 248, 1);
                .chat-content{
                    img{
                        width: 24px;
                    }
                }
                .dialog-list{
                    width: 100%;
                    float: left;
                    margin-bottom: 16px;
                    .bgleft{
                        padding: 8px 0;
                        border-radius: 8px;
                        height: 100%;
                        float: left;
                        padding-right: 10px;
                        width: 100%;
                        display: flex;
                    }
                    .bgright{
                        padding: 8px 0;
                        border-radius: 8px;
                        color: #fff;
                        height: 100%;
                        float: right;
                        padding-left: 10px;
                        display: flex;
                    }
                    img{
                        width: 32px;
                        height: 32px;
                        border-radius: 16px;
                        margin-right: 10px;
                        margin-left: 10px;
                    }
                    font-size: 12px;
                }
            }
        }
        
    }
</style>
